import InterestModal from "@/core/components/modal";
import Overlay from "@/core/components/modal/overlay";
import { useModalStore } from "@/store/modal/store";
import { XIcon } from "@phosphor-icons/react";
import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MandateQuestionnaireWrapper from "./mandate-questionnaire-wrapper";

const ManagementMandateModal = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState<number>(1);
  const { modal, setModal } = useModalStore();

  const handleBackStep = () => {
    if (step === 1) {
      close();
    } else {
      setStep(step - 1);
    }
  }

  const handleNextStep = () => {
    if (step === 1) {
      setStep(2);
    } else {
      // Instead of navigating, go to step 3 (questionnaire)
      setStep(3);
    }
  }

  const close = () => {
    setModal({ managementMandate: false });
  }

  useEffect(() => {
    if (!modal.managementMandate) {
      setStep(1)
    }
  }, [modal.managementMandate])

  return (
    <AnimatePresence>
      {modal.managementMandate && (
        <Overlay close={close}>
          <InterestModal>
            {step === 3 ? (
              // Step 3: Show questionnaire in modal
              <MandateQuestionnaireWrapper onClose={close} />
            ) : (
              // Steps 1 & 2: Introduction screens
              <div className="general-modal">
                <div className="general-modal__header">
                  {t(step === 1 ? 'management_mandate.management_mandate' : 'management_mandate.investor_profile_on_digital_assets')}
                  <div className="general-modal__close" onClick={close}>
                    <XIcon />
                  </div>
                </div>
                <div className="general-modal__content">
                  {
                    step === 1 ? <div>{t("management_mandate.start")}</div>
                      : <div>
                        {t("management_mandate.start_content_1")}
                        <br />
                        <br />
                        {t("management_mandate.start_content_2")}
                        <br />
                        <br />
                        {t("management_mandate.start_content_3")}
                        <br />
                        <br />
                        {t("management_mandate.start_content_4")}
                      </div>
                  }
                </div>
                <div className="general-modal__footer">
                  <div className={'cta-button cta-medium cta-grey'} onClick={handleBackStep}>
                    {t(step === 1 ? 'common.maybe_later' : 'common.back')}
                  </div>
                  <div className={'cta-button cta-medium cta-blue'} onClick={handleNextStep}>
                    {t(step === 1 ? 'common.next' : 'common.start')}
                  </div>
                </div>
              </div>
            )}
          </InterestModal>
        </Overlay>
      )}
    </AnimatePresence>
  )
}

export default ManagementMandateModal
